SCM.CitationModal = (function () {

    return {
        registerCitationModalEvents: registerCitationModalEvents,
        enableCitationDownloadOnFormatSelect: enableCitationDownloadOnFormatSelect
    };

    function registerCitationModalEvents(citationModalId) {
        var citationModalIdSelector = '#' + citationModalId;
        $(document.body).on('click', '[data-reveal-id="' + citationModalId + '"]', function () {
            $(citationModalIdSelector).foundation('reveal', 'open');
        });
        $(document.body).on('opened.fndtn.reveal', citationModalIdSelector, function () {
            $('select[class=\'citation-download-format\']').prop('selectedIndex', 0);
            $('.citation-download-link').addClass('disabled');
            $('.citation-download-format').focus();
        });
        $(document.body).on('closed.fndtn.reveal', citationModalIdSelector, function () {
            var $stickyToolbar = $('.js-sticky-toolbar');
            if ($stickyToolbar.hasClass('stuck')) {
                $stickyToolbar.find('.js-cite-button').focus();
            }
            else {
                $('.js-content-body').find('.js-cite-button').focus();
            }
        });
    }

    function enableCitationDownloadOnFormatSelect() {
        $(document.body).on('change', '.citation-download-format', function () {
            $('.citation-download-link').removeClass('disabled');
        });
    }

})();